import React, { Component } from 'react';
import { Bar } from 'victory';
import { equals, isNil } from 'ramda';
import { number, string, shape, func } from 'prop-types';

import { HoveredDate as IHoveredDate } from '../../models';

export class GenericBar extends Component {
  isHovered(hoveredId, hoveredDate) {
    const thisDate = this.props.datum.date;
    return (
      hoveredId === this.props.datum.id &&
      (isNil(hoveredDate) || isNil(thisDate) || hoveredDate === thisDate)
    );
  }

  isTransparent(selectedId) {
    return !isNil(selectedId) && selectedId !== this.props.datum.id;
  }

  getPropsToCompare = ({ selectedId, hoveredId, hoveredDate, ...props }) => ({
    ...props,
    isHovered: this.isHovered(hoveredId, hoveredDate),
    isTransparent: this.isTransparent(selectedId),
  });

  shouldComponentUpdate(nextProps) {
    return !equals(
      this.getPropsToCompare(this.props),
      this.getPropsToCompare(nextProps),
    );
  }

  render() {
    const {
      hoverHPadding,
      topPadding,
      hoveredId,
      hoveredDate,
      selectedId,
      onMouseOver,
      onMouseOut,
      onClick,
      ...props
    } = this.props;
    // XXX: Without the key prop bars don't rerender sometimes (fixes #382)
    return (
      <g
        className={`bar-${props.datum.id}`}
        data-x={props.datum.x}
        key={`${props.datum.id}-${props.datum.x}`}
      >
        <Bar
          {...props}
          y0={props.y0}
          y={topPadding}
          x0={props.x0 - hoverHPadding}
          style={{
            fill: this.isHovered(hoveredId, hoveredDate)
              ? 'rgba(224, 224, 224, 0.25)'
              : 'transparent',
            width: props.datum.width + hoverHPadding * 2,
            shapeRendering: 'crispEdges',
          }}
          events={{
            onMouseOver: params => onMouseOver(this.props.datum, params),
            onMouseOut: () => onMouseOut(this.props.datum),
            onClick: () => onClick(this.props.datum),
          }}
        />
        <Bar
          {...props}
          style={{
            ...props.style,
            opacity: this.isTransparent(selectedId) ? 0.3 : 1.0,
            pointerEvents: 'none',
          }}
        />
      </g>
    );
  }
}

GenericBar.propTypes = {
  hoverHPadding: number.isRequired,
  topPadding: number.isRequired,
  hoveredId: string,
  hoveredDate: IHoveredDate,
  selectedId: string,
  onMouseOver: func.isRequired,
  onMouseOut: func.isRequired,
  onClick: func.isRequired,
  y0: number,
  x0: number,
  datum: shape({
    width: number.isRequired,
    id: string.isRequired,
    date: IHoveredDate,
  }),
};

export default GenericBar;



// WEBPACK FOOTER //
// ./src/components/GenericBarChart/GenericBar.jsx